import { useRef } from 'react'

export function useResizeHandler() {
  const dragHandlerRef = useRef<HTMLDivElement>(null)
  const dragContainerRef = useRef<HTMLDivElement>(null)

  const minHeight = 100
  const maxHeight = 580

  let resizing = false
  let newHeight = 0
  let stoppedAt = minHeight

  const handleStartResizing = () => {
    resizing = true
    document.body.addEventListener('touchmove', handleResize)
    document.body.addEventListener('touchend', handleFinishResizing)
  }

  const handleResize = (e: TouchEvent) => {
    if (resizing && dragContainerRef?.current) {
      newHeight = document.body.scrollHeight - e.changedTouches[0].clientY
      dragContainerRef.current.style.height = `${Math.round(newHeight)}px`
    } else {
      handleFinishResizing()
    }
  }

  const handleFinishResizing = () => {
    resizing = false
    document.body.removeEventListener('touchend', handleFinishResizing)
    document.body.removeEventListener('touchmove', handleResize)

    if (dragContainerRef?.current) {
      if (newHeight < maxHeight - 70 && stoppedAt === maxHeight) {
        dragContainerRef.current.style.height = `${minHeight}px`
        stoppedAt = minHeight
      } else if (newHeight > minHeight + 50) {
        dragContainerRef.current.style.height = `${maxHeight}px`
        stoppedAt = maxHeight
      } else if (newHeight <= minHeight + 50) {
        dragContainerRef.current.style.height = `${minHeight}px`
        stoppedAt = minHeight
      }
    }
  }

  return {
    dragContainerRef,
    dragHandlerRef,
    handleStartResizing,
    handleResize,
    handleFinishResizing,
  }
}
